<template>
  <div
    class="offcanvas offcanvas-end"
    tabindex="-1"
    id="offcanvasRight"
    aria-labelledby="offcanvasRightLabel"
  >
    <div class="offcanvas-header position-fixed w-100">
      <h5 id="offcanvasRightLabel">{{ heading }}</h5>
      <button
        type="button"
        class="btn-close text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
    <div
      class="offcanvas-body d-flex flex-column"
      style="background-color: #f2efe6"
    >
      <img src="/img/ui-theme/logo.png" />
      <div class="bg-custom-cream pt-2">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-10 col-xl-9">
              <p class="text-center mb-4 mt-2 form-intro-text">
                Register now for exclusive early access to designs and pricing.
              </p>
              <h1 class="text-center form-title">REGISTRATION OF INTEREST</h1>

              <div
                v-if="submissionMessage"
                :class="[
                  'alert',
                  'alert-' + submissionMessage.type,
                  'alert-dismissible',
                  'fade',
                  'show',
                  'mt-4',
                ]"
                role="alert"
              >
                {{ submissionMessage.text }}
                <button
                  type="button"
                  class="btn-close"
                  @click="closeMessage"
                  aria-label="Close"
                ></button>
              </div>

              <form @submit.prevent="throttledHandleSubmit" class="form-form">
                <div class="row form-col">
                  <div class="col-12 col-md-6 form-col">
                    <input
                      type="text"
                      name="firstName"
                      placeholder="First Name *"
                      class="form-control form-control-minimal"
                      v-model="formData.firstName"
                      required
                    />
                  </div>
                  <div class="col-12 col-md-6 form-col">
                    <input
                      type="text"
                      name="lastName"
                      placeholder="Last Name *"
                      class="form-control form-control-minimal"
                      v-model="formData.lastName"
                      required
                    />
                  </div>
                </div>

                <div class="row form-col">
                  <div class="col-12 col-md-6 form-col">
                    <input
                      type="tel"
                      name="mobile"
                      placeholder="Mobile *"
                      class="form-control form-control-minimal"
                      v-model="formData.mobile"
                      required
                    />
                  </div>
                  <div class="col-12 col-md-6 form-col">
                    <input
                      type="email"
                      name="email"
                      placeholder="Email *"
                      class="form-control form-control-minimal"
                      v-model="formData.email"
                      required
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-center mb-4">
                  <div className="form-interest">
                    <select
                      name="interest"
                      id="interest"
                      required
                      class="form-select form-control-minimal"
                      v-model="formData.interest"
                    >
                      <option value="" disabled selected>
                        What are you interested in? *
                      </option>
                      <option value="2-bed">2 bed</option>
                      <option value="3-bed">3 bed</option>
                      <option value="4-bed">4 bed</option>
                      <option value="4plus-bed">4+ bed</option>
                    </select>
                  </div>
                </div>

                <div class="row form-row justify-content-center">
                  <div class="col-12 checkbox-container">
                    <div class="form-check align-items-start small">
                      <div>
                        <input
                          type="checkbox"
                          name="updates"
                          required
                          id="agree"
                          class="form-check-input minimal-checkbox me-3 mt-1"
                          v-model="formData.updates"
                        />
                        <label
                          for="agree"
                          class="form-check-label text-secondary"
                        >
                          By checking box you agree to receive updates.
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="text-center mt-3 mb-4 form-check-label">
                  By clicking Submit you consent to our
                  <a href="#" class="text-decoration-underline text-dark">
                    Privacy Policy
                  </a>
                  .
                </div>

                <div class="w-100 text-center form-bottom">
                  <button type="submit" class="btn btn-submit-minimal">
                    SUBMIT
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

// --- Props ---
const props = defineProps({
  heading: String,
})

// --- Utility Functions ---

/**
 * Throttle a function execution to a maximum of once per limit time period.
 * @param {Function} func The function to throttle.
 * @param {Number} limit The time period (in milliseconds) to limit the execution.
 * @returns {Function} The throttled function.
 */
const throttle = (func, limit) => {
  let inThrottle = false
  return function (...args) {
    if (!inThrottle) {
      func.apply(this, args)
      inThrottle = true
      setTimeout(() => (inThrottle = false), limit)
    }
  }
}

// Define the initial state for form data, including new fields from the React code
const initialData = {
  firstName: '',
  lastName: '',
  postcode: '', // Added
  email: '',
  mobile: '',
  company: '', // Added (not in template but in submit data)
  howHeard: '', // Added
  interest: '',
  comments: '', // Added
  updates: false,
}

const formData = ref({ ...initialData }) // Use a spread to create a copy for initial state
const submissionMessage = ref(null)

// Function to handle the form submission logic (with API call)
const handleSubmit = async () => {
  const updatedData = {
    location: '50sunset',
    data: JSON.stringify({
      'First Name': formData.value.firstName,
      'Last Name': formData.value.lastName,
      Email: formData.value.email,
      Mobile: formData.value.mobile,
      'What are you interested in?': formData.value.interest,
      'Get Updates': formData.value.updates,
    }),
  }

  try {
    const originalString = `hbhotel&& ${new Date().toDateString()}`
    const encodedString = btoa(originalString)
    const response = await fetch(
      'https://test.metaluxe.com.au/api/v1/feedback_forms',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${encodedString}`,
        },
        body: JSON.stringify({
          feedback_forms: updatedData,
        }),
      }
    )

    // Check for a successful response (status 200-299)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    // You can process the response body if needed, but the original code just awaited it
    await response.json()

    // Success state
    submissionMessage.value = {
      type: 'success',
      text: 'Thanks for registering! A member of the Sunset Residences team will be in touch shortly',
    }

    // Reset form data to initial state after successful submission
    formData.value = { ...initialData }
  } catch (error) {
    console.error('Submission error:', error)

    // Error state
    submissionMessage.value = {
      type: 'danger',
      text: 'There was an error with your submission. Please try again.',
    }
  }

  // Automatically clear the message after a delay
  setTimeout(() => {
    closeMessage()
  }, 5000)
}

// Create the throttled version of the submit handler
const throttledHandleSubmit = throttle(handleSubmit, 5000) // 5000ms (5 seconds) limit

const closeMessage = () => {
  submissionMessage.value = null
}
</script>

<style scoped>
#offcanvas-bod {
  overflow: hidden;
}
img {
  height: 45px;
  text-align: center;
  margin: auto;
  margin-top: 25px;
  margin-bottom: 0px;
}
.form-form {
  padding: 0;
}
.form-row {
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}
.form-col {
  margin-bottom: 5px;
}
.form-check {
  width: 100%;
  margin: auto;
  padding-left: 0em;
}
.form-check-label {
  line-height: 1.5;
  font-weight: 400;
  text-align: center;
  font-size: 14px;
  line-height: 24px;
  color: #000 !important;
}
.form-title {
  font-size: 1.2rem;
  line-height: 2rem;
  font-weight: 700;
  color: #000;
  font-family: Inter, sans-serif;
  margin-top: 2rem !important;
  margin-bottom: 1rem !important;
}

.form-intro-text {
  letter-spacing: 0.05em;
  font-size: 1.2rem;
  line-height: 2rem;
  color: #000;
  font-family: Inter, sans-serif;
}
.form-control-minimal {
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
  border-bottom-width: 2px;
  color: #000;
  font-family: Inter, sans-serif;
}
.title-separator {
  /* Horizontal line matching the image */
  border: none;
  border-top: 1px solid #000;
  width: 60%;
  margin: 2rem auto;
}

/* Minimalist Form Controls (Bottom-border only) */
.form-control-minimal {
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #000;
  background-color: transparent;
  padding: 0.5rem 0;
  box-shadow: none;
  font-size: 1rem;
  height: auto;
}

.form-control-minimal:focus {
  border-color: #000;
  box-shadow: none;
  background-color: transparent;
}

.form-control-minimal::placeholder {
  color: #000;
  opacity: 1;
}
.form-control-minimal:focus::placeholder {
  opacity: 0.5;
}
.form-interest {
  width: 100%;
}
.form-bottom {
  padding-top: 0;
}
/* Styling for the Select Dropdown */
.minimal-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /* Custom arrow for the minimal dark look */
  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23000%22%20d%3D%22M287%20177.3c-1.3%201.3-3.2%202-5.2%202h-276.4c-2%200-3.9-.7-5.2-2-2.6-2.6-2.6-6.8%200-9.4l138.2-138.2c2.6-2.6%206.8-2.6%209.4%200l138.2%20138.2c2.6%202.6%202.6%206.8%200%209.4z%22%2F%3E%3C%2Fsvg%3E') !important;
  background-size: 0.8rem;
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  transform: rotate(180deg);
}

/* Styling for the Textarea */
.minimal-textarea {
  resize: none;
  border: none;
  border-bottom: 1px solid #000;
  padding-bottom: 3rem;
}

/* Styling for the Checkbox */
.minimal-checkbox {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 0;
  border: 1px solid #000;
  margin-top: 0.1rem;
  background-color: transparent;
}
.minimal-checkbox:checked {
  background-color: #000;
  border-color: #000;
}
.minimal-checkbox:focus {
  box-shadow: none;
}

/* Submit Button */
.btn-submit-minimal {
  border-bottom: 1px solid #000;
  color: #000;
  font-weight: bold;
  letter-spacing: 0.1em;
  border-radius: 0;
  transition: background-color 0.3s;
}
.offcanvas-body {
  padding: 0;
}
@media (min-width: 576px) {
  .form-interest {
    width: 50%;
  }
  img {
    height: 60px;
    margin-bottom: 55px;
  }
  .form-form {
    padding: 1.5rem;
  }
  .form-title {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .form-row {
    margin-top: 3rem;
    margin-bottom: 1.5rem;
  }
  .form-col {
    margin-bottom: 1.5rem;
  }
  .form-check {
    width: 40%;
    padding-left: 1.5em;
  }
  .form-bottom {
    padding-top: 1.5rem;
  }
  .form-intro-text {
    font-size: 1.5rem;
  }
  .form-title {
    font-size: 1.5rem;
  }
}
</style>
